
import React, { useState, useEffect } from 'react';
import { 
    MenuBarContainerStyled,
    MenuButtonContainerStyled, 
    MenuListStyled,
    MenuButtonLineTopStyled,
    MenuButtonLineBottomStyled,
    MenuButtonLineMiddleStyled,
    MenuItemStyled,
    MenuContainerStyled,
    MenuItemIconStyled,
    MenuTitleStyled,
    MenuItemNameStyled,
    NavFooterStyled,
    NavFooterLabel,
    MenuOverlay,
    MenuHeader,
    MenuHeaderTitle,
    MenuCloseButton,
    MenuSection
 } from '../styles/Nav'
import iconMap from '../data/iconMap';
import { useNavigate } from 'react-router-dom'
import ThemeToggle from './ThemeToggle';
import { IoClose } from 'react-icons/io5';
import { LogoStyled } from '../styles/Nav';

function Hamburger({ user, setFormStep, menuOpen, setMenuOpen, logOut, handleThemeChange, logo, onLogoClick }) {
    const navigate = useNavigate();
    const [headerVisible, setHeaderVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const isMobile = window.innerWidth <= 1200;
            
            if (!isMobile) {
                setHeaderVisible(true);
                return;
            }
            
            if (currentScrollY > lastScrollY && currentScrollY > 80) {
                setHeaderVisible(false);
            } else {
                setHeaderVisible(true);
            }
            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    const handleMenuClick = () => {
        setMenuOpen(menuOpen===1?0:1);
    }
      
    const handleLinkClick = () => {
        setFormStep(0)
        navigate("/");
        setMenuOpen(0);
    }

    const handleUserClick = () => {
        navigate("/profile");
        setMenuOpen(0);
    }

    const handleFAQClick = () => {
        navigate("/faq");
        setMenuOpen(0);
    }

    const handleLogOut = async () => {
        try {
            await logOut()
            setMenuOpen(0);
            navigate("/");
        } catch (error) {
            alert(error.message)
            console.log(error);
        }
    }

    return (
        <div>
            <MenuBarContainerStyled $hidden={!headerVisible && menuOpen !== 1}>
                <LogoStyled onClick={onLogoClick} src={logo} alt='logo' className="mobile-logo" />
                <MenuButtonContainerStyled $open={menuOpen} onClick={handleMenuClick}>
                    <MenuButtonLineTopStyled $open={menuOpen} />
                    <MenuButtonLineMiddleStyled $open={menuOpen} />
                    <MenuButtonLineBottomStyled $open={menuOpen} />
                </MenuButtonContainerStyled>
            </MenuBarContainerStyled>
            
            <MenuOverlay $open={menuOpen === 1} onClick={() => setMenuOpen(0)} />
            
            <MenuContainerStyled $open={menuOpen === 1}>
                <MenuHeader>
                    <MenuHeaderTitle>Menu</MenuHeaderTitle>
                    <MenuCloseButton onClick={() => setMenuOpen(0)}>
                        <IoClose />
                    </MenuCloseButton>
                </MenuHeader>
                <MenuListStyled>
                    <MenuSection>
                        <MenuItemStyled $delay="0.05s" onClick={handleLinkClick}>
                            <MenuItemIconStyled>{iconMap['Home']}</MenuItemIconStyled>
                            <MenuItemNameStyled>Analysis</MenuItemNameStyled>
                        </MenuItemStyled>
                        <MenuItemStyled $delay="0.1s" onClick={handleFAQClick}>
                            <MenuItemIconStyled>{iconMap['Info']}</MenuItemIconStyled>
                            <MenuItemNameStyled>FAQ & Support</MenuItemNameStyled>
                        </MenuItemStyled>
                    </MenuSection>
                    {user && (
                        <MenuSection>
                            <MenuTitleStyled>Account</MenuTitleStyled>
                            <MenuItemStyled $delay="0.15s" onClick={handleUserClick}>
                                <MenuItemIconStyled>{iconMap['User']}</MenuItemIconStyled>
                                <MenuItemNameStyled>Profile</MenuItemNameStyled>
                            </MenuItemStyled>
                            <MenuItemStyled $delay="0.2s" onClick={handleLogOut}>
                                <MenuItemIconStyled>{iconMap['Signout']}</MenuItemIconStyled>
                                <MenuItemNameStyled>Sign out</MenuItemNameStyled>
                            </MenuItemStyled>
                        </MenuSection>
                    )}
                </MenuListStyled>
                <NavFooterStyled>
                    <NavFooterLabel>Theme</NavFooterLabel>
                    <ThemeToggle $mobile={false} onClick={handleThemeChange} />
                </NavFooterStyled>
            </MenuContainerStyled>
        </div>
    );
}

export default Hamburger;
